import { FormPostalCodeField, FormTextField } from 'components/form';
import { Column, Header, Row, Spacer, Typo } from 'components/ui-kit';
import { useFormikContext } from 'formik';
import { RegionAndCityRow } from './components';
import { RUSSIA_CODE } from '../../offer-form.consts';

export const DeliveryForm = (): JSX.Element => {
  const { values } = useFormikContext<{ country?: string }>();
  const IS_FOREIGN_COUNTRY = RUSSIA_CODE !== values.country?.toLowerCase();

  return (
    <>
      <Header weight="600" level={3}>
        Доставка по России
      </Header>
      <Row>
        <Spacer size={24} />
        <RegionAndCityRow isForeignCountry={IS_FOREIGN_COUNTRY} />
        <Column span={{ s: 12, l: 6 }}>
          <FormTextField
            label="Улица, дом, квартира *"
            name="address1"
            isAutocomplete={false}
          />
        </Column>
        <Column span={{ s: 12, l: 6 }}>
          <FormPostalCodeField
            label={`Индекс ${IS_FOREIGN_COUNTRY ? '' : '*'}`}
            isNotMasked={IS_FOREIGN_COUNTRY}
            name="postcode"
            validate={(value: string) =>
              IS_FOREIGN_COUNTRY || value ? undefined : 'Обязательное поле'
            }
          />
          {!IS_FOREIGN_COUNTRY && (
            <>
              <Spacer size={8} />
              <Typo variant="m">
                <a
                  href="https://www.pochta.ru/indexes"
                  target="_blank"
                  rel="noreferrer"
                >
                  Узнать свой индекс
                </a>
              </Typo>
            </>
          )}
        </Column>
      </Row>
    </>
  );
};
